import { render } from "./Corporate.vue?vue&type=template&id=4be9d0ab&ts=true"
import script from "./Corporate.vue?vue&type=script&lang=ts"
export * from "./Corporate.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__